import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Adminsidebar = () => {
  return (
    <>
      <div className='sidebar-wrapper'>

        <div className='logo-wrapper'>
          <Typography variant='h2'>
            Aiims App
          </Typography>
        </div>

        <div className='daboard-menu-wrapper'>

         
          <Link to="/admin/public" className='sidebar-link'>
            Dashboard
          </Link>

          <Link to="/admin/public" className='sidebar-link'>
            Public
          </Link>
        
          <Link to="/admin/private" className='sidebar-link'>
            Private
          </Link>

          <Link to="/login" className='sidebar-link'>
            Doctor Details
          </Link>

        </div>

      </div>
    </>
  );
};

export default Adminsidebar;